import { render } from "./g-checkbox-field.vue?vue&type=template&id=53c679f2&ts=true"
import script from "./g-checkbox-field.vue?vue&type=script&lang=tsx"
export * from "./g-checkbox-field.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__